import React, { useEffect, useState } from 'react';
import { useMsal } from '@azure/msal-react';

const REDIRECT_SECONDS = 6;

export const AccessDenied: React.FC = () => {
    const { instance } = useMsal();
    const [secondsLeft, setSecondsLeft] = useState(REDIRECT_SECONDS);

    useEffect(() => {
        if (secondsLeft <= 0) {
            // Clear anything from the failed session before sending them back,
            // so a retry starts completely clean.
            sessionStorage.removeItem('accountName');
            sessionStorage.removeItem('accountResolverRedirectTarget');

            // Full sign-out, not just a navigate — otherwise MSAL still has
            // the same (unauthorized) account cached and the user would
            // land right back on this same screen.
            instance.logoutRedirect({ postLogoutRedirectUri: '/' });
            return;
        }

        //const timer = setTimeout(() => setSecondsLeft((s) => s - 1), 1000);
        //return () => clearTimeout(timer);
    }, [secondsLeft, instance]);

    const handleReturnNow = () => {
        sessionStorage.removeItem('accountName');
        sessionStorage.removeItem('accountResolverRedirectTarget');
        instance.logoutRedirect({ postLogoutRedirectUri: '/' });
    };

    return (
        <div style={styles.page}>
            <div style={styles.card}>
                <div style={styles.iconCircle}>
                    <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
                        <path
                            d="M12 9v4m0 4h.01M10.29 3.86l-8.18 14.18A2 2 0 0 0 3.82 21h16.36a2 2 0 0 0 1.71-2.96L13.71 3.86a2 2 0 0 0-3.42 0z"
                            stroke="#B5533C"
                            strokeWidth="1.8"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                </div>
                <h1 style={styles.title}>Access Denied</h1>
                <p style={styles.message}>
                    Your account isn't registered with this organization's workspace.
                    If you believe this is a mistake, please contact your administrator.
                </p>
                <p style={styles.redirectText}>
                    Returning to sign-in in <strong>{secondsLeft}</strong> second{secondsLeft === 1 ? '' : 's'}…
                </p>
                <button style={styles.button} onClick={handleReturnNow}>
                    Return to sign-in now
                </button>
            </div>
        </div>
    );
};

const styles: { [key: string]: React.CSSProperties } = {
    page: {
        minHeight: '100vh',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#F4F6F9',
        fontFamily: 'inherit',
    },
    card: {
        backgroundColor: '#FFFFFF',
        borderRadius: 12,
        boxShadow: '0 4px 24px rgba(0,0,0,0.08)',
        padding: '48px 40px',
        maxWidth: 420,
        width: '90%',
        textAlign: 'center',
    },
    iconCircle: {
        width: 64,
        height: 64,
        borderRadius: '50%',
        backgroundColor: '#FDECEC',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        margin: '0 auto 20px',
    },
    title: {
        fontSize: 22,
        fontWeight: 600,
        color: '#1A1A2E',
        margin: '0 0 12px',
    },
    message: {
        fontSize: 14.5,
        color: '#555',
        lineHeight: 1.6,
        margin: '0 0 20px',
    },
    redirectText: {
        fontSize: 13,
        color: '#888',
        margin: '0 0 24px',
    },
    button: {
        backgroundColor: '#2B2A52',
        color: '#FFFFFF',
        border: 'none',
        borderRadius: 8,
        padding: '10px 24px',
        fontSize: 14,
        fontWeight: 500,
        cursor: 'pointer',
    },
};